module.exports = __webpack_public_path__ + "static/media/tabs-lower-banner.565a4d19.svg";